// Helper function to add leading zeros for hours (optional)
function pad(n, len) {
  return n.toString().padStart(len, "0");
}

// Function to calculate Easter Day
function calculateEasterday(year) {
  const a = year % 19;
  const b = Math.floor(year / 100);
  const c = year % 100;
  const d = Math.floor(b / 4);
  const e = b % 4;
  const f = Math.floor((b + 8) / 25);
  const g = Math.floor((b - f + 1) / 3);
  const h = (19 * a + b - d - g + 15) % 30;
  const i = Math.floor(c / 4);
  const k = c % 4;
  const l = (32 + 2 * e + 2 * i - h - k) % 7;
  const m = Math.floor((a + 11 * h + 22 * l) / 451);
  const month = Math.floor((h + l - 7 * m + 114) / 31);
  const day = ((h + l - 7 * m + 114) % 31) + 1;
  return new Date(year, month - 1, day); // Returns Easter Day
}

// Function to calculate holidays
function calculateHolidays(year) {
  const easterday = calculateEasterday(year);
  return [
    new Date(year, 0, 1), // Nytårsdag
    new Date(easterday.getTime() - 3 * 24 * 60 * 60 * 1000), // Skærtorsdag
    new Date(easterday.getTime() - 2 * 24 * 60 * 60 * 1000), // Langfredag
    easterday, // Påskedag
    new Date(easterday.getTime() + 24 * 60 * 60 * 1000), // Anden Påskedag
    new Date(easterday.getTime() + 39 * 24 * 60 * 60 * 1000), // Kristi himmelfartsdag
    new Date(easterday.getTime() + 49 * 24 * 60 * 60 * 1000), // Pinsedag
    new Date(easterday.getTime() + 50 * 24 * 60 * 60 * 1000), // Anden pinsedag
    new Date(year, 5, 5), // Grundlovsdag
    new Date(year, 11, 24), // Juleaften
    new Date(year, 11, 25), // Første Juledag
    new Date(year, 11, 26), // Anden Juledag
    new Date(year, 11, 31), // Nytårsaften
  ];
}

// Check if the date is a holiday
function isHoliday(date, holidays) {
  return holidays.some(
    (holiday) =>
      date.getDate() === holiday.getDate() &&
      date.getMonth() === holiday.getMonth() &&
      date.getFullYear() === holiday.getFullYear()
  );
}

function updateDeliveryInfo() {
  const now = new Date();
  const cutoffHour = 14;
  let targetTime = new Date(now);

  // Check if it's before or after 14:00
  if (now.getHours() >= cutoffHour) {
    // After 14:00: Set to next day
    targetTime.setDate(targetTime.getDate() + 1);
  }
  targetTime.setHours(cutoffHour, 0, 0, 0); // Set time to 14:00

  let holidays = calculateHolidays(targetTime.getFullYear()); // Initial holidays for current year

  // Skip weekends and holidays
  while (
    targetTime.getDay() === 0 || // Sunday
    targetTime.getDay() === 6 || // Saturday
    isHoliday(targetTime, holidays)
  ) {
    // Move to next day and check for year change
    targetTime.setDate(targetTime.getDate() + 1);
    targetTime.setHours(cutoffHour, 0, 0, 0); // Set time to 14:00

    // If the year has changed, update holidays
    if (targetTime.getFullYear() !== now.getFullYear()) {
      holidays = calculateHolidays(targetTime.getFullYear());
    }
  }

  // Calculate remaining time until next delivery
  const timeLeft = Math.max(0, targetTime - now);
  const hrs = Math.floor(timeLeft / (1000 * 60 * 60));
  const mins = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));

  // Construct the countdown display (no seconds)
  let countdownHTML = "";

  // If there are hours left, display hours
  if (hrs > 0) {
    countdownHTML = `${hrs}<span class="timer-text-small"> t.&nbsp;&nbsp;</span>`;
  }

  // For minutes, just display the number without padding
  countdownHTML += `${mins}<span class="timer-text-small"> min.&nbsp;&nbsp;</span>`;

  document.getElementById("countdownTimer").innerHTML = countdownHTML;

  // Determine the correct delivery day
  const deliveryDay = targetTime.toLocaleDateString("da-DK", {
    weekday: "long",
  });

  let deliveryMessage;
  if (now.getHours() < cutoffHour) {
    if (
      now.getDay() === 0 || // Sunday
      now.getDay() === 6 || // Saturday
      isHoliday(now, holidays)
    ) {
      // If before 14:00 on a weekend or holiday, show next available day
      deliveryMessage = `så sender vi din ordre ${deliveryDay}.`;
    } else {
      // Otherwise, show today
      deliveryMessage = "så sender vi din ordre i dag.";
    }
  } else {
    // After 14:00
    deliveryMessage = `så sender vi din ordre ${deliveryDay}.`;
  }

  document.getElementById("timeRemain").innerHTML = `Bestil inden&nbsp;`;
  document.getElementById("forDelivery").innerHTML = deliveryMessage;
}

// Call the function immediately to set the initial countdown
updateDeliveryInfo();
setInterval(updateDeliveryInfo, 60000); // Update every minute
